import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";

import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { getSingleClient, updateClient } from "store/actions";
import Loader from "components/shared/Loader";
import ImageUpdate from "components/shared/ImageUpdate";

const EditSocial = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const { handleSubmit } = useForm();

  const { singleClient, loading } = useSelector((state) => state?.clients);

  const [selectedImage, setSelectedImage] = useState({
    preview: "",
    path: "",
  });

  useEffect(() => {
    dispatch(getSingleClient({ id }));
  }, [dispatch, id]);

  useEffect(() => {
    setSelectedImage({
      preview: singleClient?.image,
      path: singleClient?.image,
    });
  }, [singleClient]);

  const onSubmit = (data) => {
    data.image = selectedImage.path;

    dispatch(
      updateClient({
        data,
        id,
        navigate,
        toast,
      })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card card-client">
          <div className="card-head">
            <h4>تعديل البيانات</h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={10} md={12}>
                <Row>
                  <Col lg={12} xs={12}>
                    <div className="form-group required">
                      <h5>صورة العميل</h5>
                      <ImageUpdate
                        selectedImage={selectedImage}
                        setSelectedImage={setSelectedImage}
                      />
                      {!selectedImage.path && (
                        <p className="error-hint">يرجي اختيار صورة العميل</p>
                      )}
                    </div>
                  </Col>
                  <Col lg={4} xs={12}>
                    <div className="form-group">
                      <button type="submit" className="btn btn-blue">
                        تعديل
                      </button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditSocial;
